export const getApiPath = (): string => 'https://api.mizfa.tools/v2';
export const getBaseApiPath = (): string => 'https://srv.mizfa.tools';
/** b_nest product API — `/api_backlink/v1/*` (local hub :4000). Override with VITE_BACKLINK_API_URL. */
export const getBacklinkApiPath = (): string =>
  import.meta.env.VITE_BACKLINK_API_URL || 'http://localhost:4000';
export const getWpHelpPath = (): string =>
  'https://help.mizfa.tools/wp-json/wp/v2/';
export const priceApiPath = (): string =>
  'https://text.img-cdn-cloud.com/api/collections';
export const getIndexerApiPath = (): string =>
  `${getBaseApiPath()}/indexer/v1`;

function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

/** Public MCP prefix, e.g. https://mcp.mizfa.tools/mcp */
export const getMcpBaseUrl = (): string =>
  stripTrailingSlash(
    import.meta.env.VITE_MCP_BASE_URL || 'mcp',
  );

/** Foreign MCP prefix for clients that cannot reach the Iran origin. */
export const getMcpIntlBaseUrl = (): string =>
  stripTrailingSlash(
    import.meta.env.VITE_MCP_INTL_BASE_URL ||
      'https://mcp-global.mizfa.tools/mcp',
  );

function mcpOrigin(baseUrl: string): string {
  try {
    return new URL(baseUrl).origin;
  } catch {
    return stripTrailingSlash(baseUrl).replace(/\/mcp$/, '');
  }
}

export const getMcpChatUrl = (): string => `${getBaseApiPath()}/mcp/v1/chat`;


/** Public MCP URL for agents: `https://host/agents`. */
export const getMcpHttpUrl = (): string => `${mcpOrigin(getMcpBaseUrl())}/agents`;
export const getMcpIntlHttpUrl = (): string =>
  `${mcpOrigin(getMcpIntlBaseUrl())}/agents`;
/** Public OAuth API: `https://mcp.mizfa.tools/oauth` (no `/mcp` prefix). */
export const getMcpOAuthBase = (): string =>
  `${mcpOrigin(getMcpBaseUrl())}/oauth`;


export const getCrawlSocket = (jobPage: string): string =>
  `wss://srv.mizfa.tools/khazesh/v1/web_socket/ws/${jobPage}`;
export const webSocketUrl =
  'wss://srv.mizfa.tools/connection/websocket';

